import { GQLCompany } from '../../generated/gql';
import { companyStore } from './companyStore';

export const setActiveCompany = (activeCompany: GQLCompany) => {
  companyStore.update((state) => ({ ...state, activeCompany }));
};
